import React, { useEffect, useState } from "react";
import addToMailchimp from "gatsby-plugin-mailchimp";

// Primitives
import Button from "../primitives/Button";
import WrapRotation from "../primitives/WrapRotation";

const Newsletter = () => {
  const mailChimpEN =
    "https://y-oslo.us1.list-manage.com/subscribe/post?u=b2b7628fe68612e86f36ffcbd&amp;id=77e3b14ef5&amp;f_id=0056c1e5f0";
  const mailChimpNO =
    "https://netlife.us1.list-manage.com/subscribe/post?u=b2b7628fe68612e86f36ffcbd&amp;id=5fc95bbb15&amp;f_id=000ac0e5f0";
  const [email, setEmail] = useState("");
  const [subscribeOk, setSubscribeOk] = useState(null);
  const [language, setLanguage] = useState("no");
  const [mailchimpEndpoint, setMailChimpEndpoint] = useState(mailChimpNO);

  useEffect(() => {
    setMailChimpEndpoint(language === "no" ? mailChimpNO : mailChimpEN);
  }, [language]);

  const handleSubmit = async e => {
    e.preventDefault();
    const result = await addToMailchimp(
      email,
      {
        id: language === "en" ? "77e3b14ef5" : "5fc95bbb15",
      },
      mailchimpEndpoint
    );
    setSubscribeOk(result);
  };

  return (
    <div className="pt-16">
      <div
        className="
          flex flex-col items-start
          w-full 
          mb-3
          px-4 md:px-8
          pt-4 md:pt-8
          pb-8 md:pb-16
          bg-black
        "
      >
        <h2
          className="
            w-full
            md:max-w-md
            mb-4
            text-white
            text-xl uppercase
          "
        >
          Don't miss a thing. <br /> Get on our mailing list.
        </h2>
        {!subscribeOk ? (
          <form className="w-full" onSubmit={handleSubmit}>
            <div className="flex items-center">
              <p className="mr-3 text-white">CHOOSE LANGUAGE: </p>
              <button
                type="button"
                className={`
                    border-3 xl:border-5 border-white
                    p-1
                    mr-4
                    text-white font-bold
                    ${language === "no" ? "bg-green text-black" : "bg-none"}`}
                onClick={() => {
                  setLanguage("no");
                }}
              >
                NO
              </button>

              <button
                type="button"
                className={`
                      border-3 xl:border-5 border-white
                      p-1
                      text-white font-bold
                      ${language === "en" ? "bg-green text-black" : "bg-none"}`}
                onClick={() => {
                  setLanguage("en");
                }}
              >
                ENG
              </button>
            </div>
            <div
              className="
                    flex
                    flex-col xl:flex-row
                    justify-between
                    mt-12"
            >
              <label
                className="
                    w-full
                    mr-2
                    mb-2 md:mb-0"
              >
                <span className="label hidden">Your email address</span>
                <WrapRotation>
                  <input
                    className="
                      p-2
                      border-white
                      bg-black
                      border-3 xl:border-5
                      text-white placeholder:text-white
                      w-full
                      -rotate-6
                      mt-4 md:mt-0
                      mb-4 md:mb-0
                    "
                    placeholder="Your email"
                    type="email"
                    name="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                  />
                </WrapRotation>
              </label>
              <Button
                type="submit"
                className="text-xl"
                clickFunction={handleSubmit}
                color="green"
              >
                Sign me up!
              </Button>

              {/* real people should not fill this in and expect good things - do not remove this or risk form bot signups */}
              <div
                style={{ position: "absolute", left: "-5000px" }}
                aria-hidden="true"
              >
                <input
                  type="text"
                  name="b_b2b7628fe68612e86f36ffcbd_67482c7f44"
                  tabIndex="-1"
                />
              </div>
            </div>
          </form>
        ) : (
          <p className="text-white">
            {/* https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml */}
            <div dangerouslySetInnerHTML={{ __html: subscribeOk.msg }} />
          </p>
        )}
      </div>
    </div>
  );
};

export default Newsletter;
